import Vue from 'vue'
import httpClient from './http'
import { getUrlParam, PATH_URL } from './index'
import { APP_VIEWS_CONFIG_PATH } from '@/enviroment/app'
import loggerService, { LOG_SUCCESS, LOG_ERROR } from './logger'
import { Store, DESIGN } from '@/store'
export const TYPE_INTERNAL_OBJECT = 'internal'
export const TYPE_EXTERNAL_OBJECT = 'external'

let _dashboardCache = {}
let _dashboardURL

const _isInternalObject = (type) => {
  return Vue.options.components[normalizeType(type)] !== undefined
}
const _loadExternalComponent = (type) => {
  if (!type) {
    loggerService.log('config', `_loadExternalComponent-${type}-Not defined type`, LOG_ERROR)
    return Promise.reject(new Error('Not defined type'))
  } else {
    const jsFile = `${type.replace(new RegExp('\\.(css|js)', 'gi'), '')}.js`
    const cssFile = `${type.replace(new RegExp('\\.(css|js|umd|min)', 'gi'), '')}.css`
    _injectCSS(cssFile)
    return _injectJavascript(jsFile)
  }
}
const _injectJavascript = (url) => {
  const name = url.split('/').slice(-1)[0].replace('.js', '').replace('.umd', '').replace('.min', '').replace(/[^0-9a-z-A-Z ]/g, '')
  if (window[name]) return window[name]

  window[name] = new Promise((resolve, reject) => {
    const script = document.createElement('script')
    script.async = true
    script.addEventListener('load', () => {
      loggerService.log('config', `_loadExternalComponent-${url}-loadedExternalComponent`, LOG_SUCCESS)
      resolve(window[name])
    })
    script.addEventListener('error', (e) => {
      loggerService.log('config', `_loadExternalComponent-${url}-${e}`, LOG_ERROR)
      reject(new Error(`Error loading ${url}`))
    })
    script.src = url
    document.head.appendChild(script)
  })
  return window[name]
}
const _injectCSS = (url) => {
  if (url && !document.getElementById(url)) {
    let head = document.getElementsByTagName('head')[0]
    let link = document.createElement('link')
    link.id = url
    link.rel = 'stylesheet'
    link.type = 'text/css'
    link.href = url
    link.media = 'all'
    head.appendChild(link)
    // head.insertAdjacentElement('afterbegin', link)
  }
}
const getView = async (id) => {
  if (window.PLKDesign) {
    return Store.getters[DESIGN.GETTERS.GET_VIEW](id)
  } else {
    const path2read = (getUrlParam(PATH_URL) || APP_VIEWS_CONFIG_PATH)
    if (_dashboardURL === path2read && _dashboardCache[id]) {
      return _dashboardCache[id]
    }
    _dashboardURL = path2read
    try {
      const response = await httpClient({
        method: 'get',
        url: `${_dashboardURL}/${id}.json`.replace(new RegExp('/+', 'gi'), '/')
      })
      _dashboardCache[id] = response.data || {}
      return _dashboardCache[id]
    } catch (e) {
      console.error(e)
      return Promise.reject(new Error(`Imposible obtain page with id '${id}''`))
    }
  }
}
const normalizeType = (type = '') => {
  if (!type) console.warn('Normalize empty type')
  return type.replace(new RegExp('/', 'gi'), '').toLowerCase()
}
const loadComponent = (type, object, field) => {
  return new Promise((resolve, reject) => {
    if (!type) {
      loggerService.log('config', `loadComponent-${type}-Not defined type`, LOG_ERROR)
      reject(new Error('Not defined type'))
    } else if (_isInternalObject(type)) {
      if (object && field && !object[field]) {
        Vue.set(object, field, Vue.options.components[normalizeType(type)])
      }
      loggerService.log('config', `loadComponent-${type}-loadedInternalObject`, LOG_SUCCESS)
      resolve({
        type: TYPE_INTERNAL_OBJECT,
        component: Vue.options.components[normalizeType(type)]
      })
    } else {
      _loadExternalComponent(type).then(component => {
        if (object && field) {
          Vue.set(object, field, component)
        }
        loggerService.log('config', `loadComponent-${type}-loadedExternalComponent`, LOG_SUCCESS)
        resolve({
          type: TYPE_EXTERNAL_OBJECT,
          component: component
        })
      }).catch(e => {
        loggerService.log('config', `loadComponent-${type}-${e}`, LOG_ERROR)
        reject(e)
      })
    }
  })
}

export default {
  getView,
  normalizeType,
  loadComponent
}
